import { linkToPatient } from "$routes/patient/links";
import { stringify } from "qs";

const appendSearch = (params: Record<string, string>) => {
  return stringify(params, { addQueryPrefix: true });
};

interface Opts {
  patientUuid?: string;
  locationId?: string;
}

const createQueryString = (opts: Opts) => {
  return appendSearch({
    locationId: opts.locationId,
    patientUuid: opts.patientUuid,
  });
};

export const PATIENT_PRESCRIPTIONS_SEGMENT = "prescriptions";
export function linkToPatientPrescriptions() {
  return `${linkToPatient()}/${PATIENT_PRESCRIPTIONS_SEGMENT}`;
}

export function linkToDispensePrescriptionOutpatient() {
  return `${linkToPatientPrescriptions()}/outpatient`;
}

export function linkToDispensePrescriptionInpatient() {
  return `${linkToPatientPrescriptions()}/inpatient`;
}

export function linkToDispensePrescriptionANC() {
  return `${linkToPatientPrescriptions()}/anc`;
}

export function linkToDispensePrescriptionANCWithParams(opts: Opts = {}) {
  return `${linkToDispensePrescriptionANC()}${createQueryString(opts)}`;
}

export function linkToDispensePrescriptionInpatientWithParams(opts: Opts = {}) {
  return `${linkToDispensePrescriptionInpatient()}${createQueryString(opts)}`;
}

export function linkToDispensePrescriptionOutpatientWithParams(
  opts: Opts = {},
) {
  return `${linkToDispensePrescriptionOutpatient()}${createQueryString(opts)}`;
}
